import type { OptJobRun } from './appliedSettingValues.types'

const DEFAULT_OPT_JOB_RUNS: OptJobRun[] = [
  {
    kind: 'outcome',
    returnIdPrefix: 'outcome_',
    aliases: { optjob_type: '$outcome_optjob_type', opt_job_type_id: '$outcome_opt_job_type_id' },
  },
  {
    kind: 'optimal',
    returnIdPrefix: 'optimal_',
    aliases: { optjob_type: '$optimal_optjob_type', opt_job_type_id: '$optimal_opt_job_type_id' },
  },
]

/** The subtypes the caller names: the string or strings in its `optjob_subtype` alias. */
export function getAliasSubtypes(overrideAlias: UiConfigAliases): string[] {
  const values = [overrideAlias.optjob_subtype].flat()

  return [...new Set(values.filter((value): value is string => typeof value === 'string'))]
}

type OptJobRunsOptions = {
  optimalSubtype?: string
  /** Its `optjob_subtype` alias names the optimal run's subtypes. */
  overrideAlias: UiConfigAliases
  /** Used by a run with no subtype of its own. */
  systemSubtypes?: Partial<Record<string, Subtype[]>>
}

/**
 * The outcome and optimal runs. Optimal gets the selected subtype, else the one the caller's aliases name; a run
 * without one gets the system's subtypes for its opt job type.
 */
export function toOptJobRuns({ optimalSubtype, overrideAlias, systemSubtypes }: OptJobRunsOptions): OptJobRun[] {
  const aliasSubtypes = getAliasSubtypes(overrideAlias)

  return DEFAULT_OPT_JOB_RUNS.map((defaultRun): OptJobRun => {
    const optJobType = overrideAlias[`${defaultRun.kind}_optjob_type`]
    const systemSubtypeNames = (typeof optJobType === 'string' ? (systemSubtypes?.[optJobType] ?? []) : []).map(
      ({ subtype }) => subtype
    )
    const ownSubtypes = defaultRun.kind === 'optimal' ? (optimalSubtype ? [optimalSubtype] : aliasSubtypes) : []

    return {
      ...defaultRun,
      subtypes: ownSubtypes.length ? ownSubtypes : systemSubtypeNames,
    }
  })
}
